// Адресна відомість обладнання СЕС «Еліос Лучки» — ДОСЛІВНО з «ТЗ для EMS box»,
// ред. 3.1, додаток Б (згенеровано з тексту документа, вручну не переписувалось).
// Позначення, вимикачі та серійні номери — як на схемі станції. Unit ID і IP
// логгера — адресат телеметрії: за ними кабінет зіставляє живі дані інвертора
// з його місцем на полі.
//
// Секції КТП за § 2.3 ТЗ: група D1 — вимикачі 1.QF*, група D2 — вимикачі 2.QF*.
// Пари УЗЕ за § 2.2: кожна батарея має PCS A (стійки 1–6) і PCS B (стійки 7–11).

export interface LuchkyInverter {
  ktp: 1 | 2 | 3;
  /** Позиційне позначення за схемою станції, напр. '11.U'. */
  designation: string;
  /** Номер позначення — для сортування. */
  pos: number;
  /** Вимикач, напр. '1.QF10'. */
  breaker: string;
  /** Секція КТП: D1 = вимикачі 1.QF*, D2 = 2.QF*. */
  group: 'D1' | 'D2';
  loggerIp: string;
  unitId: number;
  /** Очікуваний серійний номер (ТЗ, додаток Б). */
  serial: string;
}

export const LUCHKY_INVERTERS: LuchkyInverter[] = [
  { ktp: 1, designation: '1.U', pos: 1, breaker: '2.QF10', group: 'D2', loggerIp: '192.168.37.241', unitId: 201, serial: '5250KHTU258H0097' },
  { ktp: 1, designation: '2.U', pos: 2, breaker: '2.QF9', group: 'D2', loggerIp: '192.168.37.241', unitId: 202, serial: '5250KHTU258H0098' },
  { ktp: 1, designation: '3.U', pos: 3, breaker: '2.QF8', group: 'D2', loggerIp: '192.168.37.241', unitId: 203, serial: '5250KHTU258H0077' },
  { ktp: 1, designation: '4.U', pos: 4, breaker: '2.QF7', group: 'D2', loggerIp: '192.168.37.241', unitId: 204, serial: '5250KHTU258H0072' },
  { ktp: 1, designation: '5.U', pos: 5, breaker: '2.QF6', group: 'D2', loggerIp: '192.168.37.241', unitId: 205, serial: '5250KHTU258H0087' },
  { ktp: 1, designation: '6.U', pos: 6, breaker: '2.QF1', group: 'D2', loggerIp: '192.168.37.241', unitId: 206, serial: '5250KHTU258H0028' },
  { ktp: 1, designation: '7.U', pos: 7, breaker: '2.QF2', group: 'D2', loggerIp: '192.168.37.241', unitId: 207, serial: '5250KHTU258H0043' },
  { ktp: 1, designation: '8.U', pos: 8, breaker: '2.QF3', group: 'D2', loggerIp: '192.168.37.241', unitId: 208, serial: '5250KHTU258H0075' },
  { ktp: 1, designation: '9.U', pos: 9, breaker: '2.QF4', group: 'D2', loggerIp: '192.168.37.241', unitId: 209, serial: '5250KHTU258H0061' },
  { ktp: 1, designation: '10.U', pos: 10, breaker: '2.QF5', group: 'D2', loggerIp: '192.168.37.241', unitId: 210, serial: '5250KHTU258H0078' },
  { ktp: 1, designation: '11.U', pos: 11, breaker: '1.QF10', group: 'D1', loggerIp: '192.168.37.241', unitId: 111, serial: '5250KHTU258H0086' },
  { ktp: 1, designation: '12.U', pos: 12, breaker: '1.QF9', group: 'D1', loggerIp: '192.168.37.241', unitId: 112, serial: '5250KHTU258H0070' },
  { ktp: 1, designation: '13.U', pos: 13, breaker: '1.QF8', group: 'D1', loggerIp: '192.168.37.241', unitId: 113, serial: '5250KHTU258H0055' },
  { ktp: 1, designation: '14.U', pos: 14, breaker: '1.QF7', group: 'D1', loggerIp: '192.168.37.241', unitId: 114, serial: '5250KHTU258H0056' },
  { ktp: 1, designation: '15.U', pos: 15, breaker: '1.QF6', group: 'D1', loggerIp: '192.168.37.241', unitId: 115, serial: '5250KHTU258H0068' },
  { ktp: 1, designation: '16.U', pos: 16, breaker: '1.QF5', group: 'D1', loggerIp: '192.168.37.241', unitId: 116, serial: '5250KHTU258H0080' },
  { ktp: 1, designation: '17.U', pos: 17, breaker: '1.QF4', group: 'D1', loggerIp: '192.168.37.241', unitId: 117, serial: '5250KHTU258H0084' },
  { ktp: 1, designation: '18.U', pos: 18, breaker: '1.QF3', group: 'D1', loggerIp: '192.168.37.241', unitId: 118, serial: '5250KHTU258H0085' },
  { ktp: 1, designation: '19.U', pos: 19, breaker: '1.QF2', group: 'D1', loggerIp: '192.168.37.241', unitId: 119, serial: '5250KHTU258H0026' },
  { ktp: 1, designation: '20.U', pos: 20, breaker: '1.QF1', group: 'D1', loggerIp: '192.168.37.241', unitId: 120, serial: '5250KHTU258H0041' },
  { ktp: 2, designation: '21.U', pos: 21, breaker: '2.QF14', group: 'D2', loggerIp: '192.168.37.242', unitId: 221, serial: '5250KHTU258H0037' },
  { ktp: 2, designation: '22.U', pos: 22, breaker: '2.QF13', group: 'D2', loggerIp: '192.168.37.242', unitId: 222, serial: '5250KHTU258H0038' },
  { ktp: 2, designation: '23.U', pos: 23, breaker: '2.QF12', group: 'D2', loggerIp: '192.168.37.242', unitId: 223, serial: '5250KHTU258H0029' },
  { ktp: 2, designation: '24.U', pos: 24, breaker: '2.QF11', group: 'D2', loggerIp: '192.168.37.242', unitId: 224, serial: '5250KHTU258H0089' },
  { ktp: 2, designation: '25.U', pos: 25, breaker: '2.QF10', group: 'D2', loggerIp: '192.168.37.242', unitId: 225, serial: '5250KHTU258H0042' },
  { ktp: 2, designation: '26.U', pos: 26, breaker: '2.QF9', group: 'D2', loggerIp: '192.168.37.242', unitId: 226, serial: '5250KHTU258H0091' },
  { ktp: 2, designation: '27.U', pos: 27, breaker: '2.QF6', group: 'D2', loggerIp: '192.168.37.242', unitId: 227, serial: '5250KHTU258H0081' },
  { ktp: 2, designation: '28.U', pos: 28, breaker: '2.QF5', group: 'D2', loggerIp: '192.168.37.242', unitId: 228, serial: '5250KHTU258H0088' },
  { ktp: 2, designation: '29.U', pos: 29, breaker: '2.QF4', group: 'D2', loggerIp: '192.168.37.242', unitId: 229, serial: '5250KHTU258H0082' },
  { ktp: 2, designation: '30.U', pos: 30, breaker: '2.QF3', group: 'D2', loggerIp: '192.168.37.242', unitId: 230, serial: '5250KHTU258H0100' },
  { ktp: 2, designation: '31.U', pos: 31, breaker: '2.QF2', group: 'D2', loggerIp: '192.168.37.242', unitId: 231, serial: '5250KHTU258H0074' },
  { ktp: 2, designation: '32.U', pos: 32, breaker: '2.QF1', group: 'D2', loggerIp: '192.168.37.242', unitId: 232, serial: '5250KHTU258H0076' },
  { ktp: 2, designation: '33.U', pos: 33, breaker: '1.QF6', group: 'D1', loggerIp: '192.168.37.242', unitId: 133, serial: '5250KHTU258H0033' },
  { ktp: 2, designation: '34.U', pos: 34, breaker: '1.QF5', group: 'D1', loggerIp: '192.168.37.242', unitId: 134, serial: '5250KHTU258H0034' },
  { ktp: 2, designation: '35.U', pos: 35, breaker: '1.QF4', group: 'D1', loggerIp: '192.168.37.242', unitId: 135, serial: '5250KHTU258H0052' },
  { ktp: 2, designation: '36.U', pos: 36, breaker: '1.QF3', group: 'D1', loggerIp: '192.168.37.242', unitId: 136, serial: '5250KHTU258H0027' },
  { ktp: 2, designation: '37.U', pos: 37, breaker: '1.QF2', group: 'D1', loggerIp: '192.168.37.242', unitId: 137, serial: '5250KHTU258H0045' },
  { ktp: 2, designation: '38.U', pos: 38, breaker: '1.QF1', group: 'D1', loggerIp: '192.168.37.242', unitId: 138, serial: '5250KHTU258H0022' },
  { ktp: 2, designation: '39.U', pos: 39, breaker: '1.QF9', group: 'D1', loggerIp: '192.168.37.242', unitId: 139, serial: '5250KHTU258H0069' },
  { ktp: 2, designation: '40.U', pos: 40, breaker: '1.QF10', group: 'D1', loggerIp: '192.168.37.242', unitId: 140, serial: '5250KHTU258H0073' },
  { ktp: 2, designation: '41.U', pos: 41, breaker: '1.QF11', group: 'D1', loggerIp: '192.168.37.242', unitId: 141, serial: '5250KHTU258H0040' },
  { ktp: 2, designation: '42.U', pos: 42, breaker: '1.QF12', group: 'D1', loggerIp: '192.168.37.242', unitId: 142, serial: '5250KHTU258H0039' },
  { ktp: 2, designation: '43.U', pos: 43, breaker: '1.QF13', group: 'D1', loggerIp: '192.168.37.242', unitId: 143, serial: '5250KHTU258H0058' },
  { ktp: 2, designation: '44.U', pos: 44, breaker: '1.QF14', group: 'D1', loggerIp: '192.168.37.242', unitId: 144, serial: '5250KHTU258H0059' },
  { ktp: 3, designation: '45.U', pos: 45, breaker: '2.QF6', group: 'D2', loggerIp: '192.168.37.240', unitId: 45, serial: '5250KHTU258H0083' },
  { ktp: 3, designation: '46.U', pos: 46, breaker: '2.QF7', group: 'D2', loggerIp: '192.168.37.240', unitId: 46, serial: '5250KHTU258H0099' },
  { ktp: 3, designation: '47.U', pos: 47, breaker: '2.QF8', group: 'D2', loggerIp: '192.168.37.240', unitId: 47, serial: '5250KHTU258H0095' },
  { ktp: 3, designation: '48.U', pos: 48, breaker: '2.QF9', group: 'D2', loggerIp: '192.168.37.240', unitId: 48, serial: '5250KHTU258H0096' },
  { ktp: 3, designation: '49.U', pos: 49, breaker: '2.QF10', group: 'D2', loggerIp: '192.168.37.240', unitId: 49, serial: '5250KHTU258H0065' },
  { ktp: 3, designation: '50.U', pos: 50, breaker: '2.QF1', group: 'D2', loggerIp: '192.168.37.240', unitId: 50, serial: '5250KHTU258H0023' },
  { ktp: 3, designation: '51.U', pos: 51, breaker: '2.QF2', group: 'D2', loggerIp: '192.168.37.240', unitId: 51, serial: '5250KHTU258H0024' },
  { ktp: 3, designation: '52.U', pos: 52, breaker: '2.QF3', group: 'D2', loggerIp: '192.168.37.240', unitId: 52, serial: '5250KHTU258H0062' },
  { ktp: 3, designation: '53.U', pos: 53, breaker: '2.QF4', group: 'D2', loggerIp: '192.168.37.240', unitId: 53, serial: '5250KHTU258H0064' },
  { ktp: 3, designation: '54.U', pos: 54, breaker: '2.QF5', group: 'D2', loggerIp: '192.168.37.240', unitId: 54, serial: '5250KHTU258H0079' },
  { ktp: 3, designation: '55.U', pos: 55, breaker: '1.QF1', group: 'D1', loggerIp: '192.168.37.240', unitId: 155, serial: '5250KHTU258H0067' },
  { ktp: 3, designation: '56.U', pos: 56, breaker: '1.QF2', group: 'D1', loggerIp: '192.168.37.240', unitId: 156, serial: '5250KHTU258H0031' },
  { ktp: 3, designation: '57.U', pos: 57, breaker: '1.QF3', group: 'D1', loggerIp: '192.168.37.240', unitId: 157, serial: '5250KHTU258H0021' },
  { ktp: 3, designation: '58.U', pos: 58, breaker: '1.QF4', group: 'D1', loggerIp: '192.168.37.240', unitId: 158, serial: '5250KHTU258H0071' },
  { ktp: 3, designation: '59.U', pos: 59, breaker: '1.QF5', group: 'D1', loggerIp: '192.168.37.240', unitId: 159, serial: '5250KHTU258H0066' },
  { ktp: 3, designation: '60.U', pos: 60, breaker: '1.QF10', group: 'D1', loggerIp: '192.168.37.240', unitId: 160, serial: '5250KHTU258H0094' },
  { ktp: 3, designation: '61.U', pos: 61, breaker: '1.QF9', group: 'D1', loggerIp: '192.168.37.240', unitId: 161, serial: '5250KHTU258H0093' },
  { ktp: 3, designation: '62.U', pos: 62, breaker: '1.QF8', group: 'D1', loggerIp: '192.168.37.240', unitId: 162, serial: '5250KHTU258H0090' },
  { ktp: 3, designation: '63.U', pos: 63, breaker: '1.QF7', group: 'D1', loggerIp: '192.168.37.240', unitId: 163, serial: '5250KHTU258H0092' },
  { ktp: 3, designation: '64.U', pos: 64, breaker: '1.QF6', group: 'D1', loggerIp: '192.168.37.240', unitId: 164, serial: '5250KHTU258H0063' },
];

export interface LuchkyKtp { ktp: 1 | 2 | 3; name: string; loggerIp: string; loggerName: string; loggerSerial: string }

export const LUCHKY_KTPS: LuchkyKtp[] = [
  { ktp: 1, name: 'КТП-1', loggerIp: '192.168.37.241', loggerName: 'EzLogger KTP-1', loggerSerial: '93000SCA25AH0019' },
  { ktp: 2, name: 'КТП-2', loggerIp: '192.168.37.242', loggerName: 'EzLogger KTP-2', loggerSerial: '93000SCA25BH0001' },
  { ktp: 3, name: 'КТП-3', loggerIp: '192.168.37.240', loggerName: 'EzLogger KTP-3', loggerSerial: '93000SCA25BH0002' },
];

/**
 * Канал PLC EzLogger для кожної секції — з адресної таблиці станції
 * (Strabichovo_equipment_for_addressing_network_access.xlsx): Unit ID інвертора
 * = RS485 = Address PLC; D1 іде через CAN-CCO, D2 — через MAIN-CCO.
 */
export const LUCHKY_PLC_CHANNELS = {
  D1: 'CAN-CCO · PLC Transformer No. 10',
  D2: 'MAIN-CCO · PLC Transformer No. 20',
} as const;

export interface LuchkyPcs {
  name: string;
  side: 'A' | 'B';
  /** Група стійок, з якою працює цей PCS. */
  racks: string;
  ip: string;
  serial: string;
}

export interface LuchkyBess {
  id: number;
  designation: string;
  scuIp: string;
  serial: string;
  pcs: [LuchkyPcs, LuchkyPcs];
}

export const LUCHKY_BESS: LuchkyBess[] = [
  {
    id: 1, designation: '1.GB', scuIp: '192.168.37.51', serial: '25BS903711',
    pcs: [
      { name: 'T1.1', side: 'A', racks: '1–6', ip: '192.168.37.61', serial: '501523027760R9A00009' },
      { name: 'T1.2', side: 'B', racks: '7–11', ip: '192.168.37.62', serial: '501523027760R9A00010' },
    ],
  },
  {
    id: 2, designation: '2.GB', scuIp: '192.168.37.52', serial: '25BS903710',
    pcs: [
      { name: 'T1.3', side: 'A', racks: '1–6', ip: '192.168.37.63', serial: '501523027760R9A00015' },
      { name: 'T1.4', side: 'B', racks: '7–11', ip: '192.168.37.64', serial: '501523027760R9A00008' },
    ],
  },
  {
    id: 3, designation: '3.GB', scuIp: '192.168.37.53', serial: '25BS903705',
    pcs: [
      { name: 'T2.1', side: 'A', racks: '1–6', ip: '192.168.37.65', serial: '501523027760R9A00005' },
      { name: 'T2.2', side: 'B', racks: '7–11', ip: '192.168.37.66', serial: '501523027760R9A00002' },
    ],
  },
  {
    id: 4, designation: '4.GB', scuIp: '192.168.37.54', serial: '25BS903704',
    pcs: [
      { name: 'T2.3', side: 'A', racks: '1–6', ip: '192.168.37.67', serial: '501523027760R9A00007' },
      { name: 'T2.4', side: 'B', racks: '7–11', ip: '192.168.37.68', serial: '501523027760R9A00016' },
    ],
  },
  {
    id: 5, designation: '5.GB', scuIp: '192.168.37.55', serial: '25BS903707',
    pcs: [
      { name: 'T3.3', side: 'A', racks: '1–6', ip: '192.168.37.71', serial: '501523027760R9A00011' },
      { name: 'T3.4', side: 'B', racks: '7–11', ip: '192.168.37.72', serial: '501523027760R9A00012' },
    ],
  },
  {
    id: 6, designation: '6.GB', scuIp: '192.168.37.56', serial: '25BS903706',
    pcs: [
      { name: 'T3.1', side: 'A', racks: '1–6', ip: '192.168.37.69', serial: '501523027760R9A00013' },
      { name: 'T3.2', side: 'B', racks: '7–11', ip: '192.168.37.70', serial: '501523027760R9A00006' },
    ],
  },
  {
    id: 7, designation: '7.GB', scuIp: '192.168.37.57', serial: '25BS903709',
    pcs: [
      { name: 'T4.3', side: 'A', racks: '1–6', ip: '192.168.37.75', serial: '501523027760R9A00003' },
      { name: 'T4.4', side: 'B', racks: '7–11', ip: '192.168.37.76', serial: '501523027760R9A00004' },
    ],
  },
  {
    id: 8, designation: '8.GB', scuIp: '192.168.37.58', serial: '25BS903708',
    pcs: [
      { name: 'T4.1', side: 'A', racks: '1–6', ip: '192.168.37.73', serial: '501523027760R9A00001' },
      { name: 'T4.2', side: 'B', racks: '7–11', ip: '192.168.37.74', serial: '501523027760R9A00014' },
    ],
  },
];

/** Точка приєднання: єдиний авторитетний вимірювач PCC за ТЗ (§ 2.1). Кабінет його ще не опитує. */
export const LUCHKY_PCC = { device: 'Socomec DIRIS A-30', address: '192.168.37.27:9761', slaveId: 5 } as const;
export const LUCHKY_EMS_BOX = { address: '192.168.37.238' } as const;
export const LUCHKY_INVERTER_MODEL = { model: 'GoodWe GW250K-HT', nominalKw: 250 } as const;
export const LUCHKY_SOURCE = 'ТЗ для EMS box, ред. 3.1, додаток Б';

// ── Топологія за однолінійною схемою обліку (Додаток 3 до заяви
// № 62ZV62858G96001H): ПС-110 кВ → Т 110/10 кВ 16 МВА → РУ-10 кВ → 4 фідери УЗЕ
// (комірки «ком. облік до/від УЗЕ») і 3 фідери КТП (комірки «ком. облік
// виробіток»). Блок УЗЕ N — трансформатор 10/0,69 кВ 4 МВА, 4 PCS по 1 МВт і
// дві батареї; номер блоку закодовано в назві PCS (TN.x).

export const LUCHKY_SUBSTATION = {
  name: 'ПС-110 кВ «СЕС Еліос Лучки»',
  meters: 'PS1/PS2 SL761W081, 110 кВ',
  transformer: 'SFZ-16000-115 · 110/10 кВ · 16 МВА',
  bus: 'РУ-10 кВ',
  installedKw: 22352.4,
} as const;

export interface LuchkyBessBlock {
  id: 1 | 2 | 3 | 4;
  name: string;
  model: string;
  powerKw: number;
  transformer: string;
  /** Номери батарей (LUCHKY_BESS.id) цього блоку. */
  bess: number[];
}

export const LUCHKY_BESS_BLOCKS: LuchkyBessBlock[] = ([1, 2, 3, 4] as const).map((n) => ({
  id: n,
  name: `УЗЕ${n}`,
  model: 'BCS4000K-C-HUD/T4',
  powerKw: 4000,
  transformer: '10/0,69 кВ · 4 000 кВА',
  bess: LUCHKY_BESS.filter((b) => b.pcs[0].name.startsWith(`T${n}.`)).map((b) => b.id),
}));

/**
 * Комплектна КТП (MV-скид GoodWe) за кількістю інверторів: 24 × 250 кВт —
 * GW7000K-MVS, трансформатор 7 000 кВА, віддача 6 МВт; 20 × 250 кВт —
 * GW5000K-MVS, 5 000 кВА, 5 МВт. Обидві з трансформатором 10/0,8/0,8 кВ на дві
 * шини 0,8 кВ: І СШ (вимикачі 1.QF*, секція D1 ТЗ) і ІІ СШ (2.QF*, D2).
 *
 * Нумерація КТП — за ТЗ EMS box (еталонний документ станції); тип скида
 * визначається кількістю інверторів КТП, а не її номером.
 */
export const ktpSkid = (inverters: number) => inverters >= 24
  ? { model: 'GW7000K-MVS', transformer: '10/0,8/0,8 кВ · 7 000 кВА', exportKw: 6000 }
  : { model: 'GW5000K-MVS', transformer: '10/0,8/0,8 кВ · 5 000 кВА', exportKw: 5000 };
